
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcRulerPointer as ObcRulerPointerElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/ruler-pointer/ruler-pointer.js';
 
 
 

 
 export const ObcRulerPointer = createComponent({
   react: React,
   tagName: 'obc-ruler-pointer',
   elementClass: ObcRulerPointerElement,
   events: {
     
   }
  });
 
 